<template>
  <b-modal id="universityOperationsModal"
           size="xl"
           :hideFooter="true"
           centered
  >
    <template #modal-title>
      <h5 v-if="isAddModal">
        <em class="fas fa-plus send-icon"></em> Создание вуза / СПО
      </h5>
      <h5 v-else>
        <em class="fas fa-edit"></em> Редактирование вуза / СПО
      </h5>
    </template>
    <template #default>
      <b-form @submit.prevent="onSubmit">
        <b-form-group label="Общая информация"
                      label-cols-lg="3"
                      label-size="lg"
                      label-class="font-weight-bold pt-0"
                      class="mb-0"
        >
          <b-form-group label-for="title_input"
                        label-cols-sm="4"
                        label-cols-lg="3"
                        description=
                          'Пример: МБОУ «СОШ № 1» с углубленным изучением отдельных предметов'
          >
            <template v-slot:label>
              Название: <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="title_input"
              v-model="form.title"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label-for="type_input"
                        label-cols-sm="4"
                        label-cols-lg="3"
                        description=
                          'Пример: МБОУ «СОШ № 1» с углубленным изучением отдельных предметов'
          >
            <template v-slot:label>
              Тип заведения: <span class="text-danger">*</span>
            </template>
            <b-form-select
              id="type_input"
              v-model="form.type"
              :options="typesForSelect"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group label="Сайт: "
                        label-cols-sm="4"
                        label-cols-lg="3"
          >
            <b-form-input
              v-model="form.site"
              type="url"
            ></b-form-input>
          </b-form-group>
        </b-form-group>
        <b-form-group label="Местоположение"
                      label-cols-lg="3"
                      label-size="lg"
                      label-class="font-weight-bold pt-0"
                      class="mb-0"
        >
          <b-form-group label-for="city_input"
                        label-cols-sm="4"
                        label-cols-lg="3"
                        description="Пример: г. Москва"
          >
            <template v-slot:label>
              Город: <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="city_input"
              v-model="form.location.city"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label-for="federalSubject_input"
            label-cols-sm="4"
            label-cols-lg="3"
            description="Пример: Москва. Подпись на карте нужна для группировки и может отличаться от населённого пункта."
          >
            <template v-slot:label>
              Подпись на карте: <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="federalSubject_input"
              v-model="form.location.federalSubject"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label-for="address_input"
                        label-cols-sm="4"
                        label-cols-lg="3"
                        description=
                          "Формат ввода: [Почтовый индекс], [Населенный пункт], [Улица, дом]."
          >
            <template v-slot:label>
              Адрес: <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="address_input"
              v-model="form.location.address"
              placeholder=
                "194044, Санкт-Петербург, ул. Смолячкова, дом 6, корпус 1, строение 1"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label-cols-sm="4"
                        label-cols-lg="3"
                        description=
                          "Пример: 144, 170 (для СПб) или 470, 590 (для Иркутска).
                               Координаты относительно изображения карты. Если Вы хотите расположить
                               в уже созданный маркер, то укажите его координаты, посмотрев их у
                               соответствующей организации"
          >
            <template v-slot:label>
              Координаты: <span class="text-danger">*</span>
            </template>
            <b-form-row>
              <b-col>
                <b-form-input placeholder="Широта"
                              v-model="form.location.latitude"
                              type="number"
                              step="0.0000000000000001"
                />
              </b-col>
              <b-col>
                <b-form-input placeholder="Долгота"
                              v-model="form.location.longitude"
                              type="number"
                              step="0.0000000000000001"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
        </b-form-group>
        <b-button type="submit" variant="primary" style="float: right">
          <div v-if="isAddModal"><em class="fas fa-plus send-icon mr-1"></em> Добавить</div>
          <div v-else><em class="fas fa-save"></em> Сохранить</div>
        </b-button>
      </b-form>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
import organizationApi from '@/api/organization'
import { regexp } from '@/config/regexp'

export default {
  name: 'UniversityOperationsModal',
  data() {
    return {
      typesForSelect: [
        { text: 'Вуз', value: 'ВУЗ' },
        { text: 'СПО', value: 'СПО' }
      ],
      form: {
        title: '',
        type: '',
        site: '',
        location: {
          federalSubject: '',
          city: '',
          address: '',
          latitude: 0,
          longitude: 0
        }
      },
      id: null,
      addressRegexp: regexp.address
    }
  },
  props: {
    isAddModal: {
      type: Boolean,
      default() {
        return true
      }
    },
    chosenUniversity: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    chosenUniversity(newVal) {
      if (newVal) {
        const coordinates = newVal.position.split(',')
        this.form.title = newVal.title
        this.form.site = newVal.siteUrl
        this.form.type = newVal.type
        this.form.location.address = newVal.address
        this.form.location.federalSubject = newVal.federalSubject
        this.form.location.city = newVal.city
        this.form.location.latitude = +coordinates[0]
        this.form.location.longitude = +coordinates[1]
        this.id = newVal.id
      } else {
        this.form = {
          title: '',
          site: '',
          type: '',
          location: {
            federalSubject: '',
            city: '',
            address: '',
            latitude: 0,
            longitude: 0
          }
        }
      }
    }
  },
  methods: {
    onSubmit() {
      if (!this.form.location.address.match(this.addressRegexp)) {
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Некорректный ввод адреса!'
        })
      } else if (this.isAddModal) {
        const universityForAdd = {
          title: this.form.title,
          federalSubject: this.form.location.federalSubject,
          type: this.form.type,
          address: this.form.location.address,
          city: this.form.location.city,
          siteUrl: this.form.siteUrl,
          position: `${this.form.location.latitude}, ${this.form.location.longitude}`,
          contentObject: {
            title: this.form.title,
            avatar: null,
            type: this.form.type === 'СПО' ? 'СПО' : 'ВУЗ-партнер',
            status: 'черновик',
            fullDescription: null,
            shortDescription:
              `<p><strong>Адрес</strong>: ${this.form.location.address} </p>
            <p><strong>Сайт</strong>: <a href='${this.form.siteUrl}' target='_blank' class='external nobr'>${this.form.siteUrl}</a></p>`
          }
        }
        organizationApi.addUniversity(universityForAdd)
          .then(() => {
            this.pushToasts({
              title: 'Уведомление',
              message: 'Вуз / СПО успешно создано.'
            })
            this.$bvModal.hide('universityOperationsModal')
            this.$emit('universityOperationCompleted')
          })
          .catch(() => {
            this.pushToasts({
              title: 'Уведомление',
              error: true,
              message: 'Ошибка создания вуза / СПО.'
            })
          })
      } else {
        const universityForEdit = {
          id: this.id,
          type: this.form.type,
          title: this.form.title,
          federalSubject: this.form.location.federalSubject,
          address: this.form.location.address,
          city: this.form.location.city,
          siteUrl: this.form.site,
          position: `${this.form.location.latitude}, ${this.form.location.longitude}`
        }
        organizationApi.editOrganization(universityForEdit)
          .then(() => {
            this.pushToasts({
              title: 'Уведомление',
              message: 'Вуз / СПО успешно отредактирован.'
            })
            this.$bvModal.hide('universityOperationsModal')
            this.$emit('universityOperationCompleted')
          })
          .catch(() => {
            this.pushToasts({
              title: 'Уведомление',
              message: 'Ошибка редактирования вуза / СПО.',
              error: true
            })
          })
      }
    },
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    })
  }
}

</script>

<style scoped>
textarea:focus,
textarea:not(focus),
textarea:active {
  outline: none !important;
  box-shadow: none !important;
  border: 1px lightgrey solid !important;
}
</style>
